import { render, staticRenderFns } from "./MaterialCard.vue?vue&type=template&id=9ad3d02c"
import script from "./MaterialCard.vue?vue&type=script&lang=js"
export * from "./MaterialCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialCard.vue?vue&type=style&index=0&id=9ad3d02c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../.pnpm-store/v11/links/@/vue-loader/15.11.1/6eff93d7107be10a36f1ed991dd8c448aca9b1ca7fe7bab80a7f2c3e35a8f285/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports